// const API_BASE_URL ='http://10.167.138.154:8000/api/sarwa';
const API_BASE_URL ='https://priyanshi.coalfeed.in/api/sarwa';
// const MEDIA_BASE_URL ='http://10.167.138.154:8000';
const MEDIA_BASE_URL ='https://priyanshi.coalfeed.in';
export default API_BASE_URL;
export { MEDIA_BASE_URL };